//Generated File 
export const CloseBracket = `CloseBracket`;
export const Contains = `Contains`;
export const EndsWith = `EndsWith`;
export const Equal = `Equal`;
export const GreaterThan = `GreaterThan`;
export const GreaterThanOrEqual = `GreaterThanOrEqual`;
export const In = `In`;
export const LessThan = `LessThan`;
export const LessThanOrEqual = `LessThanOrEqual`;
export const NotContain = `NotContain`;
export const NotEndWith = `NotEndWith`;
export const NotEqual = `NotEqual`;
export const NotIn = `NotIn`;
export const NotStartsWith = `NotStartsWith`;
export const OpenBracket = `OpenBracket`;
export const StartsWith = `StartsWith`;
